var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#00004F","strokeWidth":"2","d":"M1.333 1.333h14.222v21.333H1.333z","key":0}),React.createElement("rect",{"width":"3.556","height":"3.556","x":"6.667","y":"15.556","fill":"#00004F","rx":"1.778","key":1})]);
}

Phone.defaultProps = {"width":"17","height":"24","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
